const rankingData = [
  {
    name: 'Rankings',
    link: '/rankings-generales/ranking-universidades-2022/',
    rankings: [
      {
        name: 'Top 10 Universidades Chilenas',
        link: '/rankings-generales/ranking-universidades-2022/',
        slug: 'ranking-universidades-2022',
        content: `<p>Desde hace 23 años, realizamos este Ranking de Universidades, nuestro objetivo sigue siendo el mismo: entregar información que sirva a los jóvenes y a sus familias para tomar una decisión informada antes de iniciar el proceso de postulación a la educación superior. Es una radiografía del año, de cómo la percepción de calidad que el mercado laboral asocia a cada plantel, la calidad de la gestión institucional, de los académicos y de los alumnos, así como los niveles de investigación alcanzados por las casas de estudio, han avanzado en los últimos 12 meses. Son estas cinco dimensiones con los cuales se construye el ranking.</p>

        <p>Por segundo año consecutivo, el Top 10 está integrado por las mismas casas de estudio. La actual medición arrojó un intercambio de posiciones: la U. Católica de Valparaíso escaló dos puestos, quedando en el 4° lugar, mientras que la U. de Santiago se quedó en el 8°. </p>
        
        <p>¿Qué tienen en común estos planteles? Reputación entre los empleadores, más de seis años de acreditación, excelencia en la investigación y un cuerpo docente donde destaca la presencia de académicos con grado de doctor. No es gratuito que encabecen la tabla cuatro casas de estudio que cuentan con siete años de acreditación, el tiempo máximo que entrega la CNA.</p>`,
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            data: {
              fundacion: '1888',
              rector: 'Ignacio Sánchez',
              sedes: 'Santiago / Villarrica',
              acreditados: '7',
              puntaje: '659,4',
            },
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            data: {
              fundacion: '1842',
              rector: 'Rosa Devés',
              sedes: 'Santiago',
              acreditados: '7',
              puntaje: '647,4',
            },
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            data: {
              fundacion: '1919',
              rector: 'Carlos Saavedra',
              sedes: 'Concepción / Chillán / Los Ángeles',
              acreditados: '7',
              puntaje: '595,0',
            },
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            data: {
              fundacion: '1924',
              rector: 'Nelson Vásquez',
              sedes: 'Valparaíso / Viña del Mar / Quilpué / Quillota',
              acreditados: '6',
              puntaje: '568,2',
            },
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            data: {
              fundacion: '1988',
              rector: 'Harald Beyer',
              sedes: 'Santiago / Viña del Mar',
              acreditados: '6',
              puntaje: '626',
            },
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
            data: {
              fundacion: '1926',
              rector: 'Juan Yuz',
              sedes: 'Valparaíso / Viña del Mar / Santiago / Concepción',
              acreditados: '6',
              puntaje: '599,7',
            },
          },

          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            data: {
              fundacion: '1954',
              rector: 'Hans Richter',
              sedes: 'Valdivia / Puerto Montt / Coyhaique',
              acreditados: '6',
              puntaje: '562,8',
            },
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            data: {
              fundacion: '1849',
              rector: 'Rodrigo Vidal',
              sedes: 'Santiago',
              acreditados: '7',
              puntaje: '581,7',
            },
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            data: {
              fundacion: '1989',
              rector: 'José Antonio Guzmán',
              sedes: 'Santiago',
              acreditados: '5',
              puntaje: '633,2',
            },
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
            data: {
              fundacion: '1989',
              rector: 'Eduardo Hebel Weiss',
              sedes: 'Temuco / Pucón / Angol',
              acreditados: '6',
              puntaje: '573,3',
            },
          },
        ],
      },
      {
        name: 'Tabla de Posiciones',
        link: '/rankings-generales/tabla-de-posiciones/',
        slug: 'tabla-de-posiciones',
        content: `<p>En esta oportunidad, 20 universidades mantuvieron sus posiciones, entre ellas destacan 13 planteles del TOP 15: PUC de Chile, de Chile, de Concepción, Adolfo Ibáñez, Austral de Chile, de Santiago de Chile, de Los Andes, de La Frontera, de Talca, Diego Portales y de Valparaíso. Otras 11 ascendieron: la U. Autónoma escaló tres puestos, la PUC de Valparaíso, U. Andrés Bello y de Tarapacá avanzaron 2 y las universidades Católica del Norte, UC de la Santísima Concepción, Mayor, San Sebastián, Finis Terrae, Central y de Las Américas, lo hicieron en uno. </p>

          <p>Entre estas alzas, destaca la U. Católica de Valparaíso, que este año se quedó en el cuarto lugar. Su ascenso se explica por sus indicadores de gestión y de investigación. En el primero tuvo un avance de 5 puestos, gracias a que aumentó en un año la acreditación, subió 11% pp. porcentuales su capacidad para que los alumnos de 2° año permanecieran en la institución y disminuyó casi un semestre la titulación de los estudiantes respecto a las mallas formales. En el segundo ranking, destaca el incremento en un 22% de sus publicaciones y en un 11% el impacto que ellas tienen en la comunidad científica internacional. </p>
          
          <p>Pero si de impacto se trata, este año, la publicaciones de la U. de Antofagasta presentan el mayor índice de impacto normalizado, el 1,52 que alcanzan sus trabajos significa que son citados un 52% más que la media mundial. </p>
          `,
        pdflink:
          'https://especiales.latercera.com/assets-ranking-universidades-2022/cortados/01-tabla-de-posiciones.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
          },
        ],
      },
      {
        name: 'Percepción de calidad del mercado laboral',
        link: '/rankings-generales/percepcion-de-calidad/',
        slug: 'percepcion-de-calidad',
        content: `
        <p>Le pedimos a los ejecutivos que deciden directa o indirectamen te la contratación de futuros profesionales en el país que evaluaran a las universidades que conforman el sistema. ¿La razón? Elaborar un estudio que mide la percepción de calidad y el nivel de conocimiento que los empleadores otor gan a estos planteles. Este año fueron 2.700 los profesionales que participaron y sus opi niones fueron recogidas, en noviembre pasado, por la empresa de estudio e inves tigación de mercados Feedback. </p>

<p>
  A excepción de las universidades de O\'Higgins y de Aysén, que comenzaron sus operaciones en 2015, los encuestados les pusieron nota a todos los planteles, sin embargo se publican los resultados de las universidades que son medidas en este ran king, es decir las 47 casas de estudio que están acreditadas.
  La sorpresa de este año, es la reaparición de la U. Diego Portales en el Top 10; ingre só a la décima posición, la misma que tenía en 2018. Solo 14 universidades mantuvie ron sus posiciones, de ellas las 9 que enca bezan el listado permanecen en sus posi ciones, por tercer año consecutivo.
</p>

<p>En esta versión, 10 universidades escalaron puestos, siendo la U. de Playa y la U. de Los Lagos las que tuvieron las mayores alzas, tres puntos cada una. Las que descienden notoriamente son la U. Metropolitana de \'22 Ciencias de la Educación, que bajó al lugar 34, la Adventista al 43 y la Academia de Humanismo Cristiano al 46. Fueron 19 los planteles que en total bajaron su nota en 2022. Las universidades Gabriela Mistral, Miguel de Cervantes, UNIACC y SEK, no registran valores para la edición 2021, ya que este año ingresan al ranking. </p>

<p>Este año, la U. Diego Portales volvió a estar entre las 10 primeras universidades del ranking; algo que no sucedía desde 2018, cuando también ocupó la décima posición. </p>

<p>La U. de Playa Ancha y la U. de Los Lagos son las grandes ganadoras, ambas saltaron tres puestos, ubicándose en el 28 y el 30, respectivamente. </p>

<p>La U. Católica, de Chile y Santa María se mantienen en el Top 3, posición que mantienen desde hace más de una década. </p>
        `,
        pdflink:
          'https://especiales.latercera.com/assets-ranking-universidades-2022/cortados/02-mercado-laboral.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
          },
        ],
      },

      {
        name: 'Percepción de calidad de la gestión',
        link: '/rankings-generales/percepcion-de-calidad-de-la-gestion/',
        slug: 'percepcion-de-calidad-de-la-gestion',
        content: `
        <p>Si bien no es el único factor que determina este ranking, los  años de acreditación institucional sigue siendo el indicador que más pesa, pues entre el mínimo yelmáximodeaños 3 y 7 años, la diferencia es sideral. En enero, la U. Católica de Valparaíso ingresó al club de las uni versidades que cuentan con siete años de acreditación y que hasta ahora solo osten taban la Católica, de Chile, de Concepción y de Santiago A estos planteles de excelencia, se suman otras nueve casas de estudio que tienen 6 años: de La Frontera, de Talca, Austral, Santa María, Católica del Norte, Adolfo Ibáñez, del Desarrollo, Andrés Bello y de los Andes. La nueva acredita ción de estas últimas dos rige desde fines de diciembre. </p>

<p>Diferente es la realidad de las universidades UNIACC, Metropolitana de Ciencias de la Educación, SEK, Gabriela Mistral y Miguel de Cervantes, las que tienen tres años de acreditación. La de U. de Viña del Mar, plantel que también cuenta con 3 años, se encuentra en proceso de recrea ditación. Mientras que la U. de Aconcagua, U. del Alba y U. Bolivariana, tienen hasta enero de 2025 para acreditarse; fecha en que por ley todos las instituciones de edu cación superior deben estar acreditadas, de no conseguirlo, pasan a ser supervisadas por el Consejo Nacional de Educación (CNED), institución que acompaña el pro ceso durante tres años, solo tras ello, la Subsecretaría de Educación puede solicitar un proceso de cierre. </p>

<p>Por otra parte, las dos universidades estatales que fueron fundadas en 2015, U. de Aysén y U. de O' ́Higgins, están eximidas de la acreditación por un plazo de cinco años; durante este tiempo han tenido un modelo de acompañamiento de la U. de Chile, el que no es vinculante, ya que es un apoyo. Sin embargo, ya iniciaron el proceso de acreditación.</p>`,

        contentafter: `<h3>Alumnos por JCE </h3>

<p>El número de alumnos por Jornada Completa Equivalente es el segundo indi cador considerado, se trata de una medida que permite estandarizar la carga acadé mica de los profesores. Si se analiza el núme ro de JCE con la matrícula 2022, en el sis tema universitario la relación es de 22 estu diantes por JCE —en 2021 era de 23,4—. Sobre ese promedio se dispara la U. Miguel de Cervantes con 38 alumnos por JCE, le siguen, con 29 estudiantes la Santa María y de Tarapacá; mientras que la Gabriela Mistral, UNIACC, Autónoma, Alberto Hurtado y Central, presentan 28 alumnos/JCE. Los planteles que presentan el menor número de JCE por alumnos son la U. Metropolitana de Ciencias de la Educación y U. de Magallanes, con 13 cada una. </p>

<p>De acuerdo a la información que registra mifuturo.cl, las tres universidades que más retienen a sus alumnos son la de Los Andes, Católica y de Chile, más del 86% de sus estudiantes continúan al tercer año. </p>

<p>El abandono estudiantil difiere entre las instituciones y según las áreas y carreras. En las universidades del Consejo de Rectores el rango de deserción a los dos años varía entre el 71% y 86%, lo que influye en el costo final de la matrícula. Quienes se encuentran en el rango inferior son las universidades de Atacama y de Magallanes. En el caso de los planteles privados, la UNIACC retiene solo al 44% de su estu diantado de segundo año, le siguen la Miguel de Cervantes (47%) y la SEK (50%). Según los expertos, la deserción en pre grado está asociada a pérdidas de eficien cia. Las universidades se ven directamen te afectadas pues dejan de percibir los recursos asociados a los estudiantes que desertan, lo que implica que deben adop tar su funcionamiento en cursos mayores que cuentan con menos alumnos. Por su parte, los jóvenes que dejan de lado sus estudios ven truncada la posibilidad de graduarse, lo que genera frustración y descontento. </p>

<p>El último estudio del SIES sobre la Retención de Primer Año en 2022, seña la que el 75% de los alumnos matricula dos en 2021 continuaron en la misma carrera este año. Ello implica una baja de 0,2 puntos porcentuales respecto al regis tro de los alumnos en 2020. </p>

<p>La tendencia al alza comenzó con la generación que ingresó a la educación superior en 2011, cuando la retención era de 69% y se vio interrumpida producto del estallido social (2019) y la pandemia (2020). El mismo informe señala que la cohorte 2019 reflejó una caída inédita a 73,6% siendo contraria a la tendencia al alza que venía reflejándose desde 2011. </p>

<p>Esa baja, según el informe “parece ser circunstancial, asociada al efecto conjun to de estallido social e inicio de la pande mia que impactó, principalmente, a los centros de formación técnica (CFT) e ins titutos profesionales (IP)”. Pero, muestra síntomas de una importante recupera ción, para la matrícula de 2021 se obser va que la retención fue de 76%. </p>

<p>Por otra parte, aquellos estudiantes que tienen beneficios (becas, gratuidad y/o créditos) tienen un menor nivel de deser ción: 80,7% continua sus estudios, mien tras que baja a un 67,2% para los estudian tes sin beneficios —una diferencia de 13,4 p.p.—. </p>

<p>Si hacemos un zoom al tipo de carre ras, las ligadas a las áreas de Salud, Agropecuaria y Educación son las que poseen las tasas de Retención de 1er año más altas: 84,9%, 84,5% y 83,6% respectivamente Mientras, que Ciencias Básicas (75%) y Tecnología (77,8%). </p>`,

        contentafter2: `<h3>Sobreduración de las carreras </h3>

<p>Las instituciones definen una duración formal —entendida como la duración esperada de una carrera, considerando el número de semestres del plan de estu dios y del proceso de titulación— para sus diferentes programas. Por lo general, se expresa en semestres, se establece el tiem po que se dedicará a las clases teóricas y prácticas, así como también a la titula ción. En general, los estudiantes tardan más en titularse que lo establecido for malmente. La duración real en 2021 fue 13,3 semestres, para un currículo establecido en 10,1 semestres. </p>

<p>
  El problema de tener un alto índice de atraso, muchas veces tiene que ver con el diseño y la estructura curricular —las exigencias de algunos planteles para otor gar títulos es mayor que en otros—, pero también involucra a los alumnos puesto que el perfil de éstos, las competencias por falencias formativas en la educación secundaria, influyen en lo que demore un joven en finalizar sus estudios.</p>

<p>Hay que tener presente que el año 2021, las carreras con mayor duración real pro medio en las universidades fueron Ingeniería Civil Electrónica, Ingeniería Civil Metalúrgica, Derecho, Ingeniería Civil Eléctrica, Ingeniería Civil Mecánica, Geología, Odontología e Ingeniería Civil Química (todas con un duración entren 16,8 y 16,2 semestres).
</p>

<p>
  Las universidades que dictan estas carreras, sobre todos las del área de la Tecnología, son precisamente las más afectadas en este indicador, pues sus alumnos tardan más en titularse.
  Según los registros, la U. Católica Silva Henríquez, la U. de Los Andes y la U. Adventista lideran este indicador, con menos de dos semestres de diferencia. En la parte inferior de la tabla, se encuen tra la U. Santa María con 5,4 semestres.
</p>`,

        contentafter3: `<h3>Alzas y retrocesos </h3>
<p>Año a año, hemos constatado como hay indicadores que determinan el cam bio en las posiciones de las casas de estu dio, uno de ellos son los años de acredi tación. Dado lo anterior, los mayores sal tos de este año se produjeron en dos ins tituciones que aumentaron en un año esta certificación: la U. Andrés Bello, pasó de 5 a 6 años, lo que le reportó subir 13 puestos (del 25 al 12), mientras que la U. de los Andes saltó del 10 al 3, gracias a sus 6 años. La U. Arturo Prat consiguió 5 años de acreditación, lo que le permitió pasar del 41 al 33. </p>

<p>A diferencia de estos tres planteles, cuyos avances se explican por el cambio en los años de acreditación, la U. San Sebastián mejoró su indicador de alumnos por JCE (en la versión pasada presentaba 29 alum nos y este año, 22). Eso significó un salto de 7 puestos, del 27 al 20. </p>

<blockquote>
Ingeniería Civil Electrónica, Derecho, Ingeniería Civil Mecánica e Ingeniería Civil, promedian más de 16 semestres de duración real.</blockqoute>

<blockquote>Está comprobado que los estudiantes con becas, gratuidad y/o créditos, tienen una menor deserción que quienes no cuentan con estos beneficios: 81% vs. 66%.</blockquote>

<blockquote>
  19 universidades, dos más que en 2021, presentan más alumnos por JCE que el promedio del sistema, que es de 22.
</blockquote>

<blockquote>
  Las mayores alzas de los planteles se deben al cambio en los años de acreditación: los 7 años otorgados, en febrero pasado, a la U. de Santiago la dejaron en el 3er lugar.
</blockquote>

<blockquote>
  Este año, las universidades Andrés Bello y de los Andes obtuvieron 6 años de acreditación, sumándose así a otros siete planteles que tienen el nivel de Excelencia.
</blockquote>

<blockquote>
  En enero, la Universidad Católica de Valparaíso obtuvo 7 años de acreditación, el máximo que otorga la CNA. La institución, que lidera el rector Nelson Vásquez, cumplió 98 años.
</blockquote>
        `,
        pdflink:
          'https://especiales.latercera.com/assets-ranking-universidades-2022/cortados/03-calidad-gestion.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
          },
          {
            name: 'Universidad Del Desarrollo',
            abbr: 'U. Del Desarrollo',
            logo: 'UDesarrollo',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
          },
          {
            name: 'Universidad de Talca',
            abbr: 'U. de Talca',
            logo: 'UTalca',
          },
        ],
      },
      {
        name: 'Percepción de calidad de los académicos',
        link: '/rankings-generales/percepcion-de-calidad-de-los-academicos/',
        slug: 'percepcion-de-calidad-de-los-academicos',
        content: `<p>Mientras en las universidades de clase mundial el cuerpo docente es conformado mayoritariamente por profesores con doctorado, en nuestro sistema universitario aún es un bien escaso: de los 47 planteles que integran el ranking, sólo ocho tienen más del 50% de sus JCE con este grado académico </p>

        <p>El informe sobre la caracterización del personal académico, publicado por el SIES en septiembre pasado, señala que este año son 85 mil los académicos que trabajan en instituciones de educación superior; un aumento de 4% con respecto a 2021, rompiendo así con la tendencia, desde hace cinco años, de la disminución de contrataciones de docentes. De éstos, 32% realizó un magíster y solo 16% un doctorado. </p>
        
        <p>Este ranking mide el nivel de formación de los académicos en Jornadas Completas Equivalentes (JCE), estándar utilizado internacionalmente porque permite considerar la importancia relativa de un profesor de acuerdo a los horas contratadas semanalmente. Una JCE corresponde a 44 horas semanales de contrato. </p>
        
        <p>Es importante destacar que si se consideran las JCE, y no simplemente el número de académicos, el porcentaje de docentes con estudios de doctorado se eleva a 26%, esta diferencia se explica porque las personas con este nivel de formación están contratadas por un mayor número de horas. </p>
        
        <p>Del total de JCE, 55,1% corresponde a hombres y un 44,9% a mujeres. La participación femenina es levemente inferior si se comparan con el número de académicas, ya que un 45,3% de las plantas docentes son mujeres, esta diferencia se da porque en promedio las mujeres están contratadas por una menor cantidad de horas a la semana que los hombres, 24,5 horas y 24,9 horas respectivamente. </p>
        
        <p>Desde 2013 que este ranking lo encabeza la U. Católica de Valparaíso. Se trata del plantel que registra el mayor índice de JCE con doctorado: 65,9%. 
        
        <p>Si bien hay un aumento en la contratación de docentes con doctorado, sólo 8 universidades tienen más del 50% de sus JCE con este grado</p>
        `,
        pdflink:
          'https://especiales.latercera.com/assets-ranking-universidades-2022/cortados/04-calidad-academicos.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
          },
          {
            name: 'Universidad del Bío-Bío',
            abbr: 'U. del Bío-Bío',
            logo: 'Ubiobio',
          },
          {
            name: 'Universidad Alberto Hurtado',
            abbr: 'U. Alberto Hurtado',
            logo: 'UAH',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
          },
          {
            name: 'Universidad de Talca',
            abbr: 'U. de Talca',
            logo: 'UTalca',
          },
          {
            name: 'Universidad de Tarapacá',
            abbr: 'U. Tarapacá',
            logo: 'UTarapaca',
          },
        ],
      },
      {
        name: 'Percepción de calidad de los alumnos',
        link: '/rankings-generales/percepcion-de-calidad-de-los-alumnos/',
        slug: 'percepcion-de-calidad-de-los-alumnos',
        content: `
        <p>Durante los últimos tres años, el Top 10 está integrado por las mismas casas de estudio. Eso sí, como es habitual, hay cambio en las posiciones. Siete son los planteles que este año mantuvieron sus posiciones: Católica, de Chile, de los Andes, Adolfo Ibáñez, de Concepción, Santa María y del Desarrollo. </p>

<p>La variación se encuentra en el 8° y 9° lugar, donde se produjo un intercambio, la U. de Santiago saltó un puesto por encima de la U. Diego Portales, dejando a esta última en el 9° lugar. Este cambio se debe al alza del promedio obtenido en la PDT por sus alumnos de primer año: de 579,37 pp. a 581,71. Al analizar los puntajes de ingreso, el mayor aumento lo tuvo la U. de Las Américas, la que subió 44,5 pp. de 444,61 a 491,07, pese a ello, su alza en el ranking fue de 1 puesto, del 43 al 42. </p>

<p>Al revisar el promedio NEM de los alumnos de primer año, se constata que la mayor alza la tuvo la U. Alberto Hurtado, subió de 6,07 a 6,20; aumento que no regsistró en el promedio PDT de sus alumnos, indicador en el que tuvo la mayor baja del sistema, de 542,73 a 528,16 (14,5 pp. de diferencia). Eso explica su descenso en este ranking, donde bajo del 25 al 21. </p>

<p>En cuanto a los promedios PDT, se mantienen cuatro universidades con más de 600 puntos de ingreso promedio: Católica, de Chile, de los Andes y Adolfo Ibáñez.</p>

<p>El NEM de los alumnos que ingresan a las universidades cada año aumenta. En 2019, 21 planteles registraron un 6,0 de promedio de notas, en 2021 subió a 34 casas de estudio y este año a 38.</p>
  
<p>Este año, la diferencia entre el plantel que registra el puntaje PDT más alto y el que tiene el más bajo es de 239 pp. (en 2021 fue de 178 pp.). Mientras los alumnos de la U. Católica anotan 659,40, los de la U. SEK alcanzan los 420,37.</p>
        `,
        pdflink:
          'https://especiales.latercera.com/assets-ranking-universidades-2022/cortados/05-calidad-alumnos.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
          },
          {
            name: 'Universidad Del Desarrollo',
            abbr: 'U. Del Desarrollo',
            logo: 'UDesarrollo',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
          },
          {
            name: 'Universidad de Talca',
            abbr: 'U. de Talca',
            logo: 'UTalca',
          },
        ],
      },
      {
        name: 'Percepción de calidad de la investigación',
        link: '/rankings-generales/percepcion-de-calidad-de-la-investigacion/',
        slug: 'percepcion-de-calidad-de-la-investigacion',
        content: `
        <p>Registrar el nivel de investigación que se desarrolla en un país, especialmente en uno como el nuestro, donde más del 95% de la investigación se realiza en las universidades, es un desafío, pues varios son los indicadores que intentan dar cuenta de su calidad. Uno de ellos es el número de publicaciones (output).</p>

<p>Entre 2017 y 2021, las universidades chilenas indexaron 111.531 trabajos a la base Scopus. Una tendencia que va al alza, si en 2017 fueron 17.492 documentos, en 2021 fueron 27.253. Históricamente es la U. de Chile la institución que más papers publica, con un promedio anual de 490 papers por sobre la U. Católica, la segunda institución que indexa el mayor número de publicaciones en el país.</p>

<p>Pero, también es importante conocer el porcentaje de trabajos que una institución publica en las revistas científicas que se ubican en el 25% más alto de cada categoría de conocimiento, denominado Q1. Un 65% de los trabajos de la U. de La Serena son publicados en revistas que pertenecen al Q1 (un aumento de 5 pp con respecto a los trabajos que indexó entre 2016 y 2020). A ella le siguen, con más del 55%, las investigaciones de las universidades de Diego Portales, Católica de Chile, de Magallanes y de Antofagasta. </p>

<p>A estos indicadores se suman el impacto que éstas tienen en la comunidad científica internacional (impacto normalizado). Y si de impacto se trata, las publicaciones de la U. de Antofagasta son citadas en un 52% más que la media mundial. </p>

<p>Nueve universidades publicaron sobre el 55% de sus trabajos en revistas del Q1. Se trata de La Serena, Diego Portales, Católica, de Magallanes, de Antofagasta, Mayor, Santa María, de Chile y Autónoma.</p>
        `,
        pdflink:
          'https://especiales.latercera.com/assets-ranking-universidades-2022/cortados/06-calidad-investigacion.pdf',
        ranking: [
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
          },
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
          },
          {
            name: 'Universidad Andrés Bello',
            abbr: 'U. A. Bello',
            logo: 'UNAB',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
          },
          {
            name: 'Universidad de La Serena',
            abbr: 'U. Serena',
            logo: 'USerena',
          },
          {
            name: 'Universidad de Antofagasta',
            abbr: 'U. Antofagasta',
            logo: 'UAntofa',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
          },
          {
            name: 'Universidad Autónoma de Chile',
            abbr: 'U. Autónoma',
            logo: 'UAutonoma',
          },
        ],
      },
    ],
  },
  {
    name: 'Top 10 por Carrera',
    link: '/rankings-por-carrera/arquitectura/',
    adid: 'div-gpt-ad-rankingu-0',
    rankings: [
      {
        name: 'Arquitectura',
        link: '/rankings-por-carrera/arquitectura/',
        slug: 'arquitectura',
        adid: 'div-gpt-ad-rankingu-0',
        content: `
          <p>En los últimos 7 años, las universidades Católica y de Chile, mantienen intactas sus posiciones. Eso sí, volvió al décimo lugar la U. de Valparaíso, puesto que tenía hasta el 2020. En 2021, fueron 3.187 alumnos los que ingresaron a primer año de Arquitectura, convirtiéndose así en la novena carrera que más estudiantes atrajo. </p>
          <p>Según mifuturo.cl, un arquitecto recién titulado puede ganar en promedio $923 mil, subiendo a $1,5 millones al 5° año de trabajo, mientras que la empleabilidad llega al 76% al segundo año laboral. De los planteles con mejores índices, destacan la PUC y la Chile: más del 80% de sus titulados se empleará al primer año. Los aranceles de esta licenciatura oscilan entre los $3 millones y $8,5 millones. Un 53% de sus estudiantes proviene de colegios subvencionados y 8 de cada 10 alumnos continúa cursando la carrera al segundo año.</p>
          `,

        pdflink:
          'https://especiales.latercera.com/assets-ranking-universidades-2022/cortados/arquitectura.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100%',
            ranking2021: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: ' 95,35%',
            ranking2021: '2',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
            percepcion: '83,62%',
            ranking2021: '4',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '82,94%',
            ranking2021: '5',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '81,54%',
            ranking2021: '3',
          },
          {
            name: 'Universidad de Talca',
            abbr: 'U. de Talca',
            logo: 'UTalca',
            percepcion: '76,91%',
            ranking2021: '6',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '76,28%',
            ranking2021: '8',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '74,21%',
            ranking2021: '10',
          },
          {
            name: 'Universidad del Bío-Bío',
            abbr: 'U. del Bío-Bío',
            logo: 'Ubiobio',
            percepcion: '74,21%',
            ranking2021: '7',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '72,91%',
            ranking2021: '10',
          },
        ],
      },
      {
        name: 'Derecho',
        link: '/rankings-por-carrera/derecho/',
        slug: 'derecho',
        adid: 'div-gpt-ad-rankingu-3',
        content: `<p>Este año la Católica de Valparaíso desplazó a la U. de Concepción, quedándose en la tercer posición. La PUC y la Chile siguen ocupando los dos primeros lugares y el resto de la tabla se mantiene intacta. </p>

          <p>Derecho es una de las disciplinas favoritas, con 9.012 matriculados en primer año y más de 45 mil personas estudian en uno de los 112 programas que existen en el país. La gran demanda por estudiarla se explica, en parte, por los sueldos. Un recién titulado promedia sobre $1,2 millones mensuales, superando los $2 millones al quinto año. A esto, se suma que el 79% de sus alumnos estará trabajando al segundo año de la titulación. Coincidiendo con la opinión de los encuestados, las 3 escuelas que lideran el ranking, son las que tienen a más del 90% de sus ex-alumnos trabajando al segundo año. </p>
          `,
        pdflink:
          'https://especiales.latercera.com/assets-ranking-universidades-2022/cortados/derecho.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100%',
            ranking2021: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '93,99%',
            ranking2021: '2',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '83,62%',
            ranking2021: '4',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '82,94%',
            ranking2021: '3',
          },

          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '82,54%',
            ranking2021: '5',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '76,91%',
            ranking2021: '6',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            percepcion: '76,28%',
            ranking2021: '7',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '74,63%',
            ranking2021: '8',
          },
          {
            name: 'Universidad de Talca',
            abbr: 'U. de Talca',
            logo: 'UTalca',
            percepcion: '74,20%',
            ranking2021: '9',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '72,91%',
            ranking2021: '10',
          },
        ],
      },
      {
        name: 'Ingeniería Civil Industrial',
        link: '/rankings-por-carrera/civil/',
        slug: 'civil',
        adid: 'div-gpt-ad-rankingu-1',
        content: `
          <p>
            Después de 8 años, la U. del Desarrollo regresó al Top 10, la última vez que estuvo fue en 2014. Pero si de sorpresas se trata, por primera vez, en los 23 años que se realiza este ranking, la Católica empata con la Chile en el primer lugar. Con los 4.522 alumnos matriculados en 2022, en los 90 programas que hay en el país, estudian 32 mil personas, de ellos un 70% corresponde a hombres. Si bien tiene una duración formal de 11,7 
            semestres, en la práctica, los alumnos tardan tres años más en titularse. Se trata de una de las carreras cuya empleabilidad se encuentra entre las más altas: 91% estará trabajando al segundo año después de titularse. El ingreso promedio para los recién egresados será de $1,7 millones y se incrementará a $2,6 millones luego de cinco años. Los sueldos pueden ser aún mejores si se ubican en el 10% superior: $4,6 millones al quinto año.
          </p>
          `,
        pdflink:
          'https://especiales.latercera.com/assets-ranking-universidades-2022/cortados/industrial.pdf',
        ranking: [
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '100%',
            ranking2021: '2',
          },
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100%',
            ranking2021: '1',
            numeroDuro: '1',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
            percepcion: '95,86%',
            ranking2021: '3',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '89,10%',
            ranking2021: '4',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '83,72%',
            ranking2021: '5',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '80,59%',
            ranking2021: '6',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '78,73%',
            ranking2021: '7',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            percepcion: '72,76%',
            ranking2021: '9',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            percepcion: '71,10%',
            ranking2021: '8',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '69,91%',
            ranking2021: '12',
          },
        ],
      },
      {
        name: 'Ingeniería Comercial',
        link: '/rankings-por-carrera/comercial/',
        slug: 'comercial',
        adid: 'div-gpt-ad-rankingu-2',
        content: `<p>El Top 10 de este ranking podría ser un club al que cuesta ingresar: desde 2015, son las mismas 10 universidades las que ocupan el cuadro de honor. El amplio campo laboral hace de esta disciplina una de las más requeridas: 8.770 nuevos alumnos ingresaron en 2022, erigiéndose como la tercera carrera más cotizada por los jóvenes, con más de 46 mil matriculados en el país. Lo anterior, se explica en parte por su empleabilidad: 77% tendrá empleo al primer año de titulado y 85% al segundo. También por la paga: los recién egresados recibirán $1.347.192, cifra que después de cinco años se elevará a más de $2 millones, pero los mejores pagados recibirán $3,7 millones mensuales, mientras que el tramo inferior percibirá $700 mil. El arancel anual oscila entre el $1 millón y $8,5 millones. Formalmente su plan de estudios dura 10 semestres, aunque puede ampliarse en 2,5 semestres.</p> 
          `,
        pdflink:
          'https://especiales.latercera.com/assets-ranking-universidades-2022/cortados/comercial.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100%',
            ranking2021: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '99,69%',
            ranking2021: '2',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            percepcion: '95,86%',
            ranking2021: '3',
          },
          {
            name: 'Universidad Técnica Federico Santa María',
            abbr: 'U.T.F. Santa María',
            logo: 'UTFSM',
            percepcion: '89,10%',
            ranking2021: '4',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '83,72%',
            ranking2021: '5',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '80,59%',
            ranking2021: '6',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '78,73%',
            ranking2021: '7',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '72,76%',
            ranking2021: '8',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '71,10%',
            ranking2021: '9',
          },
          {
            name: 'Universidad Del Desarrollo',
            abbr: 'U. Del Desarrollo',
            logo: 'UDesarrollo',
            percepcion: '69,91%',
            ranking2021: '10',
          },
        ],
      },
      {
        name: 'Medicina',
        link: '/rankings-por-carrera/medicina/',
        slug: 'medicina',
        adid: 'div-gpt-ad-rankingu-5',
        content: `<p>Aunque con cambios de posiciones, son los mismos 10 planteles que están presentes en el cuadro de honor desde 2020. Eso sí, dos casas de estudio intercambiaron posiciones: la U. de La Frontera se instaló en el sexto lugar, posición que ocupaba la del Desarrollo, la que ahora está en la octava posición. A pesar de su extensa malla curricular, un aspecto sigue manteniéndola como favorita de los alumnos: altos sueldos y gran empleabilidad. Los más de 19 mil matriculados saben que, una vez egresados, pueden llegar a ganar $2,5 millones, subiendo a $3,8 millones tras cinco años de ejercicio, llegando a $6 millones los mejores remunerados. Un mercado que también premia a los futuros médicos con un 90% de ellos trabajando tras titularse. Eso sí, es la carrera con los aranceles más altos del sistema: entre $5,7 millones y $11 millones. </p>
          `,
        pdflink:
          'https://especiales.latercera.com/assets-ranking-universidades-2022/cortados/medicina.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100%',
            ranking2021: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '96,96%',
            ranking2021: '2',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '93,17%',
            ranking2021: '3',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '91,91%',
            ranking2021: '4',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            percepcion: '84,89%',
            ranking2021: '5',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
            percepcion: '82,60%',
            ranking2021: '8',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '81,68%',
            ranking2021: '6',
          },
          {
            name: 'Universidad del Desarrollo',
            abbr: 'U. del Desarrollo',
            logo: 'UDesarrollo',
            percepcion: '81,45%',
            ranking2021: '6',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '79,28%',
            ranking2021: '9',
          },
          {
            name: 'Universidad Mayor',
            abbr: 'U. Mayor',
            logo: 'UMayor',
            percepcion: '73,77%',
            ranking2021: '10',
          },
        ],
      },
      {
        name: 'Odontología',
        link: '/rankings-por-carrera/odontologia/',
        slug: 'odontologia',
        adid: 'div-gpt-ad-rankingu-6',
        content: `<p>Al igual que el año pasado, se mantienen en los primeros lugares las universidades de Chile, de Concepción, Católica y de los Andes. Se mantiene también la matrícula, con 14 mil futuros odontólogos. El 58% de ellos estará trabajando al año de titulado, subiendo a un 79%, en el segundo año de ejercicio. Los sueldos comienzan sobre el millón de pesos y, tras cinco años, pueden subir a $2 millones, aunque los mejores pagados superarán los $3,5 millones. Por otra parte, quienes ingresen deben tener claro que en promedio tardarán 5 semestres más en titularse que lo establecido en la malla formal, pese a ello tiene una alta tasa de retención: sólo uno de cada diez estudiantes deserta tras finalizar el primer año de estudio. Y, al igual que otras carreras del área de la Salud, sus aranceles son altos, fluctuando entre los $3,7 millones y $9 millones. </p>`,
        pdflink:
          'https://especiales.latercera.com/assets-ranking-universidades-2022/cortados/odontologia.pdf',
        ranking: [
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '100%',
            ranking2021: '1',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '99,71%',
            ranking2021: '2',
          },
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '96,83%',
            ranking2021: '3',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '91,32%',
            ranking2021: '4',
          },
          {
            name: 'Universidad de Talca',
            abbr: 'U. de Talca',
            logo: 'UTalca',
            percepcion: '90,66%',
            ranking2021: '7',
          },
          {
            name: 'Universidad Mayor',
            abbr: 'U. Mayor',
            logo: 'UMayor',
            percepcion: '89.79%',
            ranking2021: '8',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
            percepcion: '86,32%',
            ranking2021: '10',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '83,95%',
            ranking2021: '6',
          },
          {
            name: 'Universidad Arturo Prat',
            abbr: 'U. Arturo Prat',
            logo: 'UAPrat',
            percepcion: '83,75%',
            ranking2021: '8',
          },
          {
            name: 'Universidad del Desarrollo',
            abbr: 'U. del Desarrollo',
            logo: 'UDesarrollo',
            percepcion: '81,16%',
            ranking2021: '19',
          },
        ],
      },
      {
        name: 'Periodismo',
        link: '/rankings-por-carrera/periodismo/',
        slug: 'periodismo',
        adid: 'div-gpt-ad-rankingu-7',
        content: `
          <p>Al igual que en las tres versiones anteriores, en este ranking se mantienen las mismas 10 universidades, siempre lideradas por las universidades Católica y de Chile. </p>

<p>Las remuneraciones y la empleabilidad se mantienen estables. Y aunque no son los sueldos más atractivos de este ranking, un periodista tras titularse ganará cerca de 878 mil pesos mensual, bordeando 1 millón 300 mil pesos al quinto año de trabajo; mientras que el 65% estará empleado.</p> 

<p>La irrupción del periodismo digital, permite que los planteles aseguren mejores proyecciones para sus titulados, lo que se traduce en importantes cambios curriculares. Es más, la U. Adolfo Ibáñez relanzará la licenciatura en 2024, por lo que no tendrá vacantes para 2023. Tampoco tendrán nuevos ingresos las universidades Mayor y Santo Tomás.</p>
`,
        pdflink:
          'https://especiales.latercera.com/assets-ranking-universidades-2022/cortados/periodismo.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100%',
            ranking2021: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '96,47%',
            ranking2021: '2',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '86,54%',
            ranking2021: '4',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '85,12%',
            ranking2021: '5',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            percepcion: '83,01%',
            ranking2021: '6',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '82,31%',
            ranking2021: '5',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '79,37%',
            ranking2021: '9',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '77,73%',
            ranking2021: '7',
          },
          {
            name: 'Universidad Del Desarrollo',
            abbr: 'U. Del Desarrollo',
            logo: 'UDesarrollo',
            percepcion: '75,93%',
            ranking2021: '10',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            percepcion: '73,83%',
            ranking2021: '9',
          },
        ],
      },
      {
        name: 'Psicología',
        link: '/rankings-por-carrera/psicologia/',
        slug: 'psicologia',
        adid: 'div-gpt-ad-rankingu-8',
        content: `<p>Al igual que en los últimos siete años, la tabla la lidera la U. Católica. Además, las mismas 10 universidades que estuvieron en el cuadro de honor en 2021, permanecen este año. Psicología fue en 2022 la carrera favorita de los estudiantes que ingresaron a primer año: 9.817. Esta cifra la convierte en la licenciatura que más matrícula convocó. Así, son 44 mil los futuros psicólogos que están en las aulas de 39 universidades. Y aunque no es una de las carreras mejores pagadas, puesto que recién al quinto año de ejercicio un psicólogo promedia $1.200.000 al mes, pero puede ascender a $1.944.000 entre los mejores pagados. Pese a que formalmente los alumnos debiesen cursarla en 10 semestres, pueden tardarse otros dos semestres. En cuanto al perfil de los futuros psicólogos, seis de cada diez estudiantes son mujeres. </p>
          `,
        pdflink:
          'https://especiales.latercera.com/assets-ranking-universidades-2022/cortados/psicologia.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100%',
            ranking2021: '1',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '98,51%',
            ranking2021: '2',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '90,36%',
            ranking2021: '4',
          },
          {
            name: 'Universidad Diego Portales',
            abbr: 'U. Diego Portales',
            logo: 'UDP',
            percepcion: '86,58%',
            ranking2021: '3',
          },
          {
            name: 'Pontificia Universidad Católica de Valparaíso',
            abbr: 'PUC de Valparaíso',
            logo: 'PUCV',
            percepcion: '86,40%',
            ranking2021: '5',
          },
          {
            name: 'Universidad Adolfo Ibáñez',
            abbr: 'U. Adolfo Ibáñez',
            logo: 'UAI',
            percepcion: '84,30%',
            ranking2021: '7',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '84,03%',
            ranking2021: '6',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '77,05%',
            ranking2021: '10',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '75,53%',
            ranking2021: '8',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            percepcion: '74,96%',
            ranking2021: '9',
          },
        ],
      },
      {
        name: 'Enfermería',
        link: '/rankings-por-carrera/enfermeria/',
        slug: 'enfermeria',
        adid: 'div-gpt-ad-rankingu-4',
        content: `
          <p>La Católica volvió al primer lugar, en la versión 2021 fue desplazada del podio por la Chile, universidad que este año quedó en la tercera posición. La gran novedad es el regreso de la Católica de la Santísima Concepción al Top 10. </p>

<p>Quienes decidan estudiar Enfermería, deberán desembolsar anualmente entre $2.800.000 y $7.000.000 en arancel. Actualmente, hay 36.521 personas estudiando en uno de los 41 programas que se dictan en el país. Se trata de la cuarta carrera con mayor matrícula. Este año, nuevamente, las cifras indican que atrás quedó la baja empleabilidad que había registrado durante un par de años: Un 92% de los enfermeros estará empleado al segundo año de titularse. </p>

<p>Los sueldos también influyen en su elección. Un recién titulado ganará $1,2 millones y subirá a $1,7 millones al quinto año de ejercicio. Además, se trata de una carrera con baja deserción (9 de cada 10 alumnos continuan en segundo año), y en la que sus estudiantes tardan poco más de 3 semestres más en terminarla. </p>`,
        pdflink:
          'https://especiales.latercera.com/assets-ranking-universidades-2022/cortados/enfermeria.pdf',
        ranking: [
          {
            name: 'Pontificia Universidad Católica de Chile',
            abbr: 'PUC de Chile',
            logo: 'PUC',
            percepcion: '100%',
            ranking2021: '2',
          },
          {
            name: 'Universidad de Concepción',
            abbr: 'U. de Concepción',
            logo: 'UdeC',
            percepcion: '98,39%',
            ranking2021: '3',
          },
          {
            name: 'Universidad de Chile',
            abbr: 'U. de Chile',
            logo: 'UChile',
            percepcion: '97,61%',
            ranking2021: '1',
          },
          {
            name: 'Universidad de Los Andes',
            abbr: 'U. de Los Andes',
            logo: 'UAndes',
            percepcion: '93,79%',
            ranking2021: '4',
          },
          {
            name: 'Universidad de Santiago de Chile',
            abbr: 'U. de Santiago de Chile',
            logo: 'USACH',
            percepcion: '88,68%',
            ranking2021: '5',
          },
          {
            name: 'Universidad Austral de Chile',
            abbr: 'U. Austral de Chile',
            logo: 'UACH',
            percepcion: '86,12%',
            ranking2021: '6',
          },
          {
            name: 'Universidad de La Frontera',
            abbr: 'U. de La Frontera',
            logo: 'UFRO',
            percepcion: '85,33%',
            ranking2021: '7',
          },
          {
            name: 'Universidad de Valparaíso',
            abbr: 'U. de Valparaíso',
            logo: 'UValpo',
            percepcion: '84,76%',
            ranking2021: '8',
          },
          {
            name: 'Universidad Católica de la Santísima Concepción',
            abbr: 'UC. de la Stma. Conce.',
            logo: 'UCSConce',
            percepcion: '83,31%',
            ranking2021: '12',
          },
          {
            name: 'Universidad Mayor',
            abbr: 'U. Mayor',
            logo: 'UMayor',
            percepcion: '82,64%',
            ranking2021: '9',
          },
        ],
      },
    ],
  },
]

export default rankingData
